export const addClass = (element, className) => {
	if (element.classList) {
		element.classList.add(className);
	} else {
		element.className += ' ' + className;
	}
};

export const removeClass = (element, className) => {
	if (element.classList) {
		element.classList.remove(className);
	} else {
		element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	}
};

export const hasClass = (element, className) => {
	if (element.classList) {
		return element.classList.contains(className);
	} else {
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
	}
};

export const append = (element, parent) => {
	parent.appendChild(element);
};

export const remove = (element) => {
	if (element && element.parentNode) {
		element.parentNode.removeChild(element);
	}
};

export const wrap = (element, wrapper) => {
	element.parentNode.insertBefore(wrapper, element);
	wrapper.appendChild(element);
};

export const createElement = (type, classes = '') => {
	const element = document.createElement(type);

	classes.split(' ').forEach((className) => addClass(element, className));

	return element;
};

export const outerWidth = (element, includeMargin) => {
	const style = window.getComputedStyle(element);
	let margin = 0;

	if (includeMargin) {
		margin = parseInt(style.marginLeft) + parseInt(style.marginRight);
	}

	return element.offsetWidth + margin;
};

export const getItemsWidth = (items) => items
	.map((item) => outerWidth(item, true))
	.reduce((sum, value) => sum + value, 0);



// WEBPACK FOOTER //
// ./src/js/tools/DOM.js